import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/')({
  validateSearch: zodValidator(withDefaults(schema.CUSTOM_DASHBOARDS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
